<template>
  <div>
    <h5 class="title is-5">
      Complete Your Profile
    </h5>
    <p class="is-size-6 u-m-b">
      Provide some basic details so your teammates can recognize you.
    </p>
    <form @submit.prevent="handleSubmitCompleteProfile">
      <b-field
        :label="completeProfileForm.firstName.label"
        :type="formErrors[completeProfileForm.firstName.name] ? 'is-danger' : ''"
        :message="formErrors[completeProfileForm.firstName.name] || ''"
      >
        <b-input
          v-model="completeProfileForm.firstName.value"
          :name="completeProfileForm.firstName.name"
          placeholder=""
          ref="firstNameInput"
        />
      </b-field>
      <b-field
        :label="completeProfileForm.lastName.label"
        :type="formErrors[completeProfileForm.lastName.name] ? 'is-danger' : ''"
        :message="formErrors[completeProfileForm.lastName.name] || ''"
      >
        <b-input
          v-model="completeProfileForm.lastName.value"
          :name="completeProfileForm.lastName.name"
          placeholder=""
        />
      </b-field>
      <b-button
        type="is-primary"
        native-type="submit"
        size="is-large"
        class="is-fullwidth"
        :loading="isFormSubmissionInProgress"
      >
        {{ submitButtonText }}
      </b-button>
    </form>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import * as UserActions from '@/store/actions/User.actions';
import * as InvitationActions from '@/store/actions/Invitation.actions';
import * as ValidationService from '@/services/Validation.service';
import { isObjectEmpty } from '@/helpers/dataHelpers';

export default {
  name: 'OnboardingCompleteProfileForm',

  props: {
    submitButtonText: {
      type: String,
      required: false,
      default: 'Complete My Profile',
    },
    activeInvitationId: {
      type: String,
      required: false,
      default: null,
    },
  },

  data() {
    return {
      completeProfileForm: {
        firstName: {
          name: 'First Name',
          label: 'First Name',
          value: '',
          required: true,
        },
        lastName: {
          name: 'Last Name',
          label: 'Last Name',
          value: '',
          required: true,
        },
      },
      formErrors: {},
      isFormSubmissionInProgress: false,
    };
  },

  computed: {
    ...mapGetters([
      'loggedInUser',
    ]),
    ...mapState({
      activeWorkspaceId: state => state.workspace.activeWorkspaceId,
      authUser: state => state.auth.authUser,
      invitations: state => state.invitation.invitations,
    }),
    activeInvitation() {
      return this.invitations[this.activeInvitationId];
    },
    updatedUserFormPayload() {
      return {
        firstName: this.completeProfileForm.firstName.value,
        lastName: this.completeProfileForm.lastName.value,
      };
    },
    acceptInvitationPayload() {
      return {
        invitationId: this.activeInvitationId,
        newUser: {
          firstName: this.completeProfileForm.firstName.value,
          lastName: this.completeProfileForm.lastName.value,
        },
        workspaceId: this.activeInvitation.workspaceId,
      };
    },
  },

  mounted() {
    this.setInitialFormState();
  },

  methods: {
    setInitialFormState() {
      this.completeProfileForm.firstName.value = this.loggedInUser.firstName;
      this.completeProfileForm.lastName.value = this.loggedInUser.lastName;

      this.$refs.firstNameInput.$el.querySelector('input').focus();
    },
    async handleSubmitCompleteProfile() {
      this.formErrors = ValidationService.runFormValidation({ ...this.completeProfileForm });
      if (!isObjectEmpty(this.formErrors)) return;

      this.isFormSubmissionInProgress = true;
      try {
        if (!this.activeInvitationId) {
          await this.$store.dispatch(
            UserActions.UPDATE_USER_PROFILE,
            { userId: this.loggedInUser.id, updatedUser: this.updatedUserFormPayload, workspaceId: this.activeWorkspaceId }, // eslint-disable-line max-len
          );
        } else {
          await this.$store.dispatch(
            InvitationActions.ACCEPT_INVITATION,
            { ...this.acceptInvitationPayload },
          );
        }

        this.$emit('submitSuccess');
        this.isFormSubmissionInProgress = false;
      } catch (err) {
        this.isFormSubmissionInProgress = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
